import "./IntakeForm.module.css";
import Header from "@/reusable_sections/Header";
import HeroArea from "./sections/HeroArea";
import ConsultationRequestForm from "./sections/ConsultationRequestForm";
import FrequentlyAskedQuestions from "./sections/FrequentlyAskedQuestions";
import Footer from "@/reusable_sections/Footer";
export default function IntakeFormPage() {
  return <div>
      <Header />
      <HeroArea />
      <ConsultationRequestForm />
      <FrequentlyAskedQuestions />
      <Footer />
    </div>;
}